import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ROOT_URL } from '../../../actions';
import { getPurchasedOrdersMember, getTerminatedVPNamesForMember, tabTracking, getPurchaseOrderExcel } from '../../../actions';
import './PurchasedOrders.css';
import _get from 'lodash/get';
import { Dropdown } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import ReactExport from "react-export-excel";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { PriceFormatter, dynamicDateFilters, monthName, jsonToParam, paramsToJSON, paramsToJSON1, jsonToParam1 } from '../../../helper';
import _find from 'lodash/find';
import _findIndex from 'lodash/findIndex';
import { matLoader } from '../../../components/Loader';
import _ from 'lodash';
import axios from "axios";
import { createThisTypeNode } from 'typescript';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
// import './modal.css';

let token = localStorage.getItem('imark-token');
console.debug("Setting Authentication Token", token);

axios.defaults.headers.common['Authorization'] = "Bearer " + token;


 
const dataTable = _.range(1, 60).map(x => ({ id: x, memberId: `memberId ${x}`, month: `month ${x}`, poDate: `poDate ${x}`, poNo: `poNo ${x}`, productDescription: `productDescription ${x}`, productId: `productId ${x}`, totalAmount: `totalAmount ${x}`, vendorId: `vendorId ${x}`, vendorIn: `vendorIn ${x}`, vendorName: `vendorName ${x}`, year: `year ${x}` }));



class PurchasedOrders extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            isClick:false,
            openModal : false,
            selectedFilter: "BOTH",
            buttonOptions: ["BOTH", "OUT", "IN"],
            params: {
                fromDate: "",
                toDate: "",
                memberId: this.props.memberIdForCorporate,
                buyingGroupId: this.props.buyingGroupId,
                dropDown: [],
                poNumber: "",
                vendorId: "",
                start: 1,
                length: "",
                invoiceNo: "",
                inOut: "both",

            },
            purchasedOrdersRows: [],
            exportData:[],
            totalSize: 0,
            page: 1,
            sizePerPage: 50,
            selected: '0',
            exceldownload:'',
        };
        this.fetchData = this.fetchData.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleSizePerPageChange = this.handleSizePerPageChange.bind(this);

    };


    isExpanded = (action) => {
        if (action === true) {
            this.setState({ expanded: true });
        } else if (action === false) {
            this.setState({ expanded: false });

        }
    }
    renderButtonGroup() {

        return this.state.buttonOptions.map((option, index) => {
            return (
                <button style={{ height: '38px' }} key={index} type="button" value={option}
                    onClick={(e) => { console.log(e.target.value); this.handleUserSelectedFilter(e.target.value) }}
                    class={`btn btn-light ${(this.state.selectedFilter === option) ? "active" : null}`}>{option}</button>
            )
        })
    }
    handleUserSelectedFilter(option) {
        this.setState({ selectedFilter: option }, () => {
            this.setFilter({ inOut: this.state.selectedFilter });
        });

    }
    componentWillMount() {

        let paramsValues = this.state.params;
        let paramsfinal = dynamicDateFilters(paramsValues);
        let params = (paramsfinal);
        this.setState({ params: params });

    }

    componentDidMount() {
        
        this.fetchData();
        this.setState({
            isLoading: true
        })
        // let params = jsonToParam1(this.state.params);
        //this.setState({ params: params });
        Promise.all([
            // this.props.getPurchasedOrdersMemberAPI(this.state.params),
            this.props.tabTrackingAPI("tabId=6"),
            this.props.getTerminatedVPNamesForMemberAPI(jsonToParam1(this.state.params)),
           // this.props.getPurchaseOrderExcelAPI(this.state.params),
        ]).then(data => {

            this.setState({
                isLoading: false
            })
        }).catch(err => {

            this.setState({
                isLoading: false
            })
        })
        
            console.log(this.state.exceldownload);

    }
    componentWillReceiveProps(nextProps) {
        this.setState({ purchasedOrdersRows: nextProps.purchasedOrdersRows })
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    fetchData(page = this.state.page, sizePerPage = this.state.sizePerPage, total) {
        let purchasedOrdersRows;

        axios.get(ROOT_URL + '/purchase-order/list?' + jsonToParam1({
            ...this.state.params, start: page,
            length: sizePerPage
        }), '?')
            .then(resp =>
                this.setState({
                    isLoading:true,
                    purchasedOrdersRows: resp.data.data,
                    totalSize: resp.iTotalRecords, page, sizePerPage
                }))
                // console.log('resp',purchasedOrdersRows)
    }

                
    exportData(){

        axios.get(ROOT_URL + '/purchase-order/list?' + jsonToParam1(this.state.params))
            .then(resp =>{
                this.setState({
                exportData:resp.data.data
                })
                console.log('resp',resp.data.data.length)
            })
    }

    handlePageChange(page, sizePerPage) {
        this.fetchData(page, sizePerPage);
    }

    handleSizePerPageChange(sizePerPage) {
        // When changing the size per page always navigating to the first page
        this.fetchData(1, sizePerPage);
    }


    setFilter = (filter) => {
        console.log(filter);
        let params = this.state.params;
        // params = paramsToJSON(params);
        if (filter.inOut === "in" || filter.inOut === "IN") {
            params.inOut = "in";
        }
        if (filter.inOut === "out" || filter.inOut === "OUT") {
            params.inOut = "out";
        }
        if (filter.inOut === "BOTH" || filter.inOut === "both") {
            params.inOut = "both";
        }
        // params = jsonToParam(params);
        this.setState({

            params: params,
            refreshData: true,
            isLoading: true,

        }, () => Promise.all([
            this.fetchData(),
            //this.props.getPurchasedOrdersMemberAPI(this.state.params),
            //this.props.getPurchaseOrderExcelAPI(this.state.params),

        ]).then(() => {
            this.setState({
                isLoading: false,
            })
        }).catch(err => {

            this.setState({
                isLoading: false
            })
        }))
    }

    showDate = (row) => {
        let date = new Date(row);
        return (
            <div>{date.toLocaleDateString()}</div>
        )
    }
    handleStartDataChange = (e) => {
        //;
        let params = this.state.params;
        //  params = paramsToJSON(params);
        params.dropDown = [...params.dropDown]
        params.fromDate = e.target.value;
        params.toDate = params.toDate;
        params.memberId = this.props.memberIdForCorporate;
        params.invoiceNo = params.invoiceNo
        params.poNumber = params.poNumber;
        //  params = jsonToParam(params);
        this.setState({
            params: params
        });
        //this.props.getPurchasedOrdersMemberAPI(params);
        // this.setState({ params : params },()=>{

        // })
    }

    handleEndDataChange = (e) => {
        let params = this.state.params;
        //  params = paramsToJSON(params);
        params.dropDown = [...params.dropDown]
        params.fromDate = params.fromDate;
        params.toDate = e.target.value;
        params.memberId = this.props.memberIdForCorporate;
        params.invoiceNo = params.invoiceNo
        params.poNumber = params.poNumber;
        //  params = jsonToParam(params);
        this.setState({
            params: params
        });
        //this.props.getPurchasedOrdersMemberAPI(params);
        // this.setState({ params : params },()=>{

        // })
    }
    handleClick = (e, value) => {
        let params = this.state.params;
        //  params = paramsToJSON(params);
        let arr = [];
        let valstr = [value.value];
        if (valstr != "" && valstr != "undefined") {
            let valueee = valstr.map((option, index) => {
                let val = _find(value.options, ['value', option])
                arr.push(val.value)
            })
            params.vendorId = arr
        }
        else {
            params.vendorId = "";
        }
        // params = jsonToParam(params);
        this.setState({
            params: params, flag: true
        });
    }

    handleSearch = (e) => {
        
        let params = this.state.params;
        //params = paramsToJSON(params);
        params.poNumber = params.poNumber;
        params.invoiceNo = params.invoiceNo;
        params.fromDate = params.fromDate;
        params.toDate = params.toDate;
        params.memberId = this.props.memberIdForCorporate;
        params.start = ''
        // params = jsonToParam(params);
        this.setState({
            params: params
        });
        
        this.fetchData();

        
    }
    handlePurchaseOrderChange = (e) => {
        let params = this.state.params;
        // params = paramsToJSON(params);
        params.poNumber = e.target.value;
        params.invoiceNo = params.invoiceNo
        params.fromDate = params.fromDate;
        params.toDate = params.toDate;
        params.memberId = this.props.memberIdForCorporate;
        // params = jsonToParam(params);
        this.setState({
            params: params
        });
        //this.props.getPurchasedOrdersMemberAPI(params);
    }
    getPurchaseOrderDefaultData = row => {

        let params = this.state.params;
        // params = paramsToJSON(params);
        this.refs.fromDate.value = '';
        this.refs.toDate.value = '';
        this.refs.poNumber.value = '';
        params.fromDate = "";
        params.toDate = "";
        params.vendorId = "";
        params.memberId = this.props.memberIdForCorporate;
        params.poNumber = "";
        params.invoiceNo = "";
        // fromDate.value= "";
        // toDate.value= "";
        // invoiceNo.value= "";
        // poNumber.value= "";
        // vendorId="";
        // params = jsonToParam(params);
        this.setState({ params: params, poNumber: '', invoiceNo: "", fromDate: "", toDate: "" })
        // this.props.getPurchasedOrdersMemberAPI(params);
        this.fetchData();

    }
    INOUTComponent = (cell, rows) => {
        let vendorIn = _get(rows, 'vendorIn', "")
        if (vendorIn == true) {
            return <div>IN</div>
        }
        else {
            return <div>OUT</div>
        }
    }

     FileDownload1 =(e)=> {
        e.preventDefault()
         console.log(this.state.params);
         this.setState({ isClick: true,
            openModal : true });
        axios({
          url:ROOT_URL + '/purchase-order/download'
          +jsonToParam1((this.state.params), '?'),
          method: 'GET',
          responseType: 'blob', 
          headers: {'Authorization': "Bearer " + token}
        
        }).then(response =>{ 
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
       link.href = url;
       link.setAttribute('download', 'Purchased_Orders.csv'); 
       document.body.appendChild(link);
       link.click();
       console.log('FileDownload1 response',response)
       this.setState({
        isClick: false,
      });

      } ) }


    
    render() {
        console.log(this.state.exceldownload);
        console.log('purchasedOrdersRows',this.state.purchasedOrdersRows);

        const { Page, sizePerPage, purchasedOrdersRows } = this.state;


        const options = {
            onPageChange: this.handlePageChange,
            onSizePerPageList: this.handleSizePerPageChange,
            page: this.state.page,
            sizePerPage: this.state.sizePerPage,
        };


        const { vendorNamesList } = this.props;

        let todayDate = new Date();
        let dateForMaxStart = todayDate.toISOString().split('T')[0];

        const ExcelFile = ReactExport.ExcelFile;
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
        let ExcelData = [];
        const fileName = "myfile";
        let params = this.state.params;
        params = paramsToJSON1(params);
        return (
            <div className="Dashboard">
                <nav className="userInfo Filters navbar">
                    <span className="navbar-brand nav-head">Purchase Orders</span>

                    <ul className="navbar-nav flexRowForFilters" >
                        <li className="nav-item">

                            <Dropdown ref="vendorId" clearable onChange={(e, value) => this.handleClick(e, value)} placeholder='Select Supplier' search fluid selection options={this.props.vendorNamesList} />
                        </li>
                        <li className="nav-item">

                            <div className="btn-group">
                                {this.renderButtonGroup()}
                            </div>
                        </li>
                        <li className="nav-item">
                            <input ref="poNumber" type="text" style={{ height: '38px' }} onChange={(e) => { console.log(e); this.handlePurchaseOrderChange(e) }} className="form-control" placeholder="Search PO"></input>
                        </li>
                        <li className="nav-item">
                            <input ref="fromDate" max={dateForMaxStart} style={{ height: '38px' }} type="date" onChange={(e) => { console.log(e); this.handleStartDataChange(e) }} className="form-control" placeholder="From Date"></input>
                        </li>
                        <li className="nav-item">
                            <input ref="toDate" max={dateForMaxStart} style={{ height: '38px' }} type="date" onChange={(e) => { console.log(e); this.handleEndDataChange(e) }} className="form-control" placeholder="To Date"></input>
                        </li>
                        <li className="nav-item">
                            <button className="btn btn-primary" style={{ height: '38px' }} onClick={(e) => { console.log(e); this.handleSearch(e) }}>Search</button>
                        </li>
                        <li className="nav-item">
                            <button className="btn btn-primary" style={{ height: '38px', float: "right" }} onClick={this.getPurchaseOrderDefaultData} >Reset</button>
                        </li>
                        
                        <li className="nav-item">
                        </li>
                    </ul>
                        {/* <a className="btn btn-primary" target ="_blank" style={{ height: '38px', marginBottom: '7px' }} download="foo.txt"
                         href={ROOT_URL + '/purchase-order/download' + jsonToParam1(this.state.params, '?')}
                         >Export</a> */}
                         {(this.state.isClick)?
                        <Modal  center
                        classNames={{
                          overlay: 'customOverlay',
                          modal: 'customModal',
                        }} open={this.state.openModal}>
                        <h4>Downloading...</h4>
                    </Modal>
                         :  <button className="btn btn-primary"
                        style={{ height: '38px', marginBottom: '7px' }} 
                         onClick={e=>this.FileDownload1(e)}>
                            Export
                         </button>  }


                        {/* <ExportToExcel apiData={this.state.exceldownload} fileName={fileName} /> */}

                            {/* <ExcelFile element={<button className="btn btn-primary" style={{ height: '38px', marginBottom: '7px' }}>Export</button>}>
                                <ExcelSheet data={this.state.exceldownload} name="Purchased Orders">
                                    <ExcelColumn label="PO NUMBER" value="poNo" />
                                    <ExcelColumn label="PO DATE" value="poDate" />
                                    <ExcelColumn label="SUPPLIER  NAME" value="vendorName" />
                                    <ExcelColumn label="VP / UNAPPROVED SUPPLIERS" value="vendorName" />
                                    <ExcelColumn label="PRODUCT DESCRIPTION" value="productDescription" />
                                    <ExcelColumn label="AMOUNT ($)" value="totalAmount" />
                                </ExcelSheet>
                            </ExcelFile> */}
                        {/* </li>
                    </ul> */}
                    {/* </div>
            </div> */}
                </nav>



                    <div className="col-12" style={{ paddingBottom: "12px", marginLeft: "" }}>
                        {/* <div className="col-12"> */}

                        <div className="card-deck">
                            <div className="card shadow-sm mb-3">

                                <div className="card-header">Purchase Order</div>
                                {console.log('purchase order table',this.state.purchasedOrdersRows)}
                                { (this.state.isLoading) ?
                                <div className="card-body" style={{ maxHeight: "400" }}>
                                    <BootstrapTable
                                        remote={true} pagination={true}
                                        data={this.state.purchasedOrdersRows}
                                        options={options}
                                        fetchInfo={{ dataTotalSize: this.state.totalSize }}
                                        search height='400' pagination striped hover version="4" >
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal', wordWrap: 'break-word' }} width="150" dataSort={true} isKey dataField='poNo'>PO Number</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal', wordWrap: 'break-word' }} width="150" dataSort={true} dataFormat={this.showDate} dataField='poDate'>PO Date</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal', wordWrap: 'break-word' }} width="250" dataSort={true} dataField='vendorName'>Supplier Name</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal', wordWrap: 'break-word' }} width="170" dataSort={true} dataFormat={this.INOUTComponent} dataField='vendorIn'>IN/OUT Supplier</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal', wordWrap: 'break-word' }} width="250" dataSort={true} dataField='productDescription'>Product Description</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal', wordWrap: 'break-word' }} width="160" dataFormat={PriceFormatter} dataSort={true} dataField='totalAmount'>Amount($)</TableHeaderColumn>
                                    </BootstrapTable>
                                </div>
                                // :<div style={{height:100,width:'100%',border:'1px solid #eee'}}><h3 style={{textAlign:'center'}}>Data is Exporting...</h3></div>}


                                :<div style={{height:100,width:'100%',border:'1px solid #eee'}}><h3 style={{textAlign:'center'}}>Loading...</h3></div>  }
                            </div></div>


                    </div>



            </div>
        )
    }
}
function mapStateToProps(state) {
    let vendorNames = [];
    let vendorNameprops = _get(state, 'member.getTerminatedVPNamesForMember', []);
    vendorNameprops && vendorNameprops.map((vname, index) => {
        let vendorNameObj = {
            key: index,
            text: vname.vendorName,
            value: vname.vendorId,
        }
        vendorNames.push(vendorNameObj)
    })
    let getPurchaseOrderExcel = _get(state, 'member.getPurchaseOrderExcel', []);

    return {
        getPurchaseOrderExcel: getPurchaseOrderExcel,
        vendorNamesList: vendorNames,
        purchasedOrdersRows: _get(state, 'member.memberPurchasedOrders', []),
        isFetching: _get(state, 'member.isFetching', true),
        memberIdForCorporate: _get(sessionStorage, 'imark-memberId', ''),
        buyingGroupId: _get(sessionStorage, 'imark-buyingGroupId', ''),
        tabTracking: _get(state, 'corporate.tabTracking', []),
        PurchaseOrderExcel: _get(state, 'member.getPurchaseOrderExcel'),
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getPurchasedOrdersMemberAPI: getPurchasedOrdersMember,
        //  getMemberVendorNamesAPI: getMemberVendorNames
        getTerminatedVPNamesForMemberAPI: getTerminatedVPNamesForMember,
        getPurchaseOrderExcelAPI: getPurchaseOrderExcel,
        tabTrackingAPI: tabTracking,
    },
        dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PurchasedOrders);
